import { Component, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import { NotificationsService } from '../../../store';
import { Router } from '@angular/router';
import { Autorisationer } from '@store/models';

@Component({
    selector: 'app-autorisationer',
    template: `
    <app-autorisationer-ui
        [autorisationer]="autorisationer$ | async"
        (openClient)="openClient($event)"
        (dismiss)="dismiss()"
    ></app-autorisationer-ui>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AutorisationerContainer {

    autorisationer$ = this.notificationsService.getAutorisationer();

    constructor(
        public activeModal: NgbActiveModal,
        private router: Router,
        private notificationsService: NotificationsService
    ) {}


    openClient(autorisation: Autorisationer) {
        this.router.navigate(['/clients', autorisation.kid]);
        this.activeModal.close();
    }

    dismiss() {
        this.activeModal.dismiss();
    }

}
